import { useEffect, useState } from 'react';
import { OrganizationApi } from '../../../api';
import { HolidaysWithBranchesDto } from '../../../commonTypes/organization.types';
import { useContainer } from '../../useContainer';

const useHttpGetHolidayByIdOnMount = (id?: string) => {
    const organizationApi: OrganizationApi = useContainer(OrganizationApi);
    const [holiday, setHoliday] = useState<HolidaysWithBranchesDto>();
    const [isHolidayReady, setIsHolidayReady] = useState<boolean>(false);

    const getHolidayById = (id: string) => {
        const { exec, abort } = organizationApi.getHolidayById({
            params: { id },
            onSuccess: res => {
                setHoliday(res.body);
                setIsHolidayReady(true);
            },
            onError: err => err,
        });
        exec();
        return abort;
    };

    useEffect(() => {
        if (id) getHolidayById(id);
    }, []);

    return { holiday, isHolidayReady };
};

export default useHttpGetHolidayByIdOnMount;
